import { Component, ojs, app } from "modular-openscriptjs";
import { pageInfo, scrollToTop, either } from "../../helpers";
import { dc, PAGES, uc } from "../../declarations";
import PaymentMethodList from "../PaymentMethodList";
import MpesaForm from "../Forms/MpesaForm";
import PaymentForm from "../Forms/PaymentForm";

const h = app("h");
const route = app("router");

ojs(PaymentMethodList, PaymentForm);

export default class PaymentPage extends Component {
    render(...args) {
        pageInfo(PAGES.PAYMENT);
        scrollToTop();

        uc.states({
            paymentMethod: "mpesa",
            currentPaymentAmount: route.params.amount,
        });

        uc.currentPaymentAmount.value = route.params.amount;

        return h.div(
            { class: "container py-md-5" },
            h.div(
                {
                    class: "col-lg-9 col-xl-7 d-flex flex-column gap-4 py-5 mb-5",
                },
                h.PaymentMethodList(),
                either(route.qs.has("editable"), () => {
                    return h.div(
                        h.h5(
                            { class: "fw-bold mb-3 text-secondary" },
                            "Edit Amount (excluding charges)",
                        ),

                        h.div(
                            { class: "card border-0 shadow-sm rounded-4" },

                            h.div(
                                { class: "card-body p-4" },
                                h.div(
                                    {
                                        class: "input-group input-group-lg mb-2",
                                    },
                                    h.span(
                                        {
                                            class: "input-group-text bg-light border-0 text-secondary fw-semibold",
                                            id: "edit-payment-amount",
                                        },
                                        "Amount",
                                    ),
                                    h.input({
                                        type: "number",
                                        class: "form-control border-0 bg-light fw-bold",
                                        aria_label: "Edit payment amount",
                                        aria_describedby: "edit-payment-amount",
                                        placeholder: "amount to pay",
                                        value: route.params.amount,
                                        oninput: this.method("editAmount", [
                                            "${this}",
                                            route.params.amount,
                                        ]),
                                    }),
                                    h.span(
                                        {
                                            class: "input-group-text bg-light border-0 fw-bold",
                                        },
                                        dc.userCurrency ?? "KES",
                                    ),
                                ),
                                h.div(
                                    {
                                        class: "form-text text-muted small ps-1",
                                    },
                                    "Pay different amounts with different payment methods or from different users until you've paid the full amount.",
                                ),
                            ),
                        ),
                    );
                }),
                h.PaymentForm(uc.paymentMethod),
            ),
            ...args,
        );
    }

    editAmount(elem, def) {
        let v = def;

        if (elem.value.length > 0 && elem.value > 0) {
            v = elem.value;
        }

        uc.currentPaymentAmount.value = v;
    }
}
